var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnnotationImages',{attrs:{"images":_vm.imageData,"project":this.projectId},on:{"open-bottom-sheet":_vm.openBottomSheet}})
}
var staticRenderFns = []

export { render, staticRenderFns }